import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AdGroupPickerComponent } from "./ad-group-picker/ad-group-picker.component";
import { MaterialTileComponent } from "./material-tile/material-tile.component";
import { PeoplePickerComponent } from "./people-picker/people-picker.component";
import { TaggerComponent } from "./tagger/tagger.component";

@NgModule({
    declarations: [
        AdGroupPickerComponent,
        PeoplePickerComponent,
        TaggerComponent,
        MaterialTileComponent,
    ],
    exports: [
        AdGroupPickerComponent,
        PeoplePickerComponent,
        TaggerComponent,
        MaterialTileComponent,
    ],
    imports: [
        CommonModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatListModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatDialogModule,
    ],
})
export class SharedModule {}
